import { ToolbarButton } from '#base/Designer/Toolbars/ToolbarButton.js';
import { ToolViewModes } from '#base/Designer/types.js';
import colorPickerIcon from '#base/resources/icons/color-picker-icon.png';
import jerseyIcon from '#base/resources/icons/jersey-icon.svg';
import Icon from '#base/ui/Icon.js';

export const JerseyToolbar = ({ mode, setMode, graphicType }) => {
  return (
    <div className='t-flex t-gap-2'>
      <ToolbarButton
        isActive={mode === ToolViewModes.ASSET}
        onClick={() => setMode(ToolViewModes.ASSET)}
        text='Styles'
        icon={
          <Icon
            url={jerseyIcon}
            color='var(--plum-brand-black)'
            className='t-h-full t-max-h-[18px] t-max-w-full'
            size={18}
          />
        }
      />

      {graphicType === 'color' && (
        <ToolbarButton
          isActive={mode === ToolViewModes.COLOR}
          onClick={() => setMode(ToolViewModes.COLOR)}
          text='Color'
          icon={
            <img
              src={colorPickerIcon}
              alt='Color Picker Icon'
              className='t-h-full t-max-h-[18px] t-max-w-full'
            />
          }
        />
      )}
    </div>
  );
};
